import React from 'react';

import PollEdit from '../../../components/Apps/FundApp/PollEdit';
import Poll from '../../../components/Apps/FundApp/Poll';

// const propTypes = {
//   params: React.PropTypes.shape({
//     schoolId: React.PropTypes.string,
//     pollId: React.PropTypes.string,
//     type: React.PropTypes.string,
//   }).isRequired,
//   location: React.PropTypes.shape({
//     pathname: React.PropTypes.string.isRequired,
//   }),
// };

const defaultProps = {
};

const PollContainer = ({ params, location }) => (
  params.pollId === 'new'
    ? <PollEdit params={params} location={location} />
    : <Poll params={params} location={location} />
);

// PollContainer.propTypes = propTypes;
PollContainer.defaultProps = defaultProps;

// TODO Надо бы сюда вынести весь connect из Poll и PollEdit

export default PollContainer;
